module.exports = __webpack_public_path__ + "static/tmsu-logo-38dbc9a064002a1d2e58d028ac60b186.png";